import { APIGet } from '../services/API'


export const getCCBEvents = (args) => (dispatch, getState) => {

    // Get Site
    const { site } = getState().Settings;

    // Dispatch Result
    dispatch({
        type: 'GETTING_CCB_EVENTS',
        payload: {
            ui: "loading"
        }
    });

    let url = site+'/api/v1/ccb/events';
    let qs = [];

    if(args.page) qs.push('page='+args.page);
    let queryString = qs.join('&');

    url += '?'+queryString;

    // Send Request To Get Events
    APIGet(url)
    .then(res => res.json())
    .then(json => {
        dispatch({ type: 'GET_CCB_EVENTS_SUCCESS',payload: {ui:"success",events:json}});
    })
    .catch(e => {
        dispatch({ type: 'GET_CCB_EVENTS_ERROR',payload: {ui:"error",message:e}});
    })

}
